import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function ResidencyInvestmentIsleMan() {

    return (
        <main className='main'>
            <IntroSection
                title="Residency & Investment – Isle of Man"
                subtitle="Secure Residency in a Leading Offshore & Financial Hub"
                description="The Isle of Man offers flexible pathways for individuals and families seeking residency, business opportunities, and tax advantages in one of the world’s most respected offshore jurisdictions. Whether you are an entrepreneur, high-net-worth individual, or investor, IoM residency provides a safe, stable, and globally connected base, with strong ties to the United Kingdom and Commonwealth markets."
                badges={[
                    "Investor Residency",
                    "Entrepreneur Visa",
                    "Business Relocation",
                    "Tax Advantages"
                ]}
                buttonText="Request an Isle of Man Residency Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/residency-passport/isle-of-man-residency.png')}
                imageAlt="Isle of Man Residency & Investment"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Choose Isle of Man Residency?"
                        blocks={[
                            {
                                items: [
                                    { text: "Tier-1 Jurisdiction — politically stable, UK-aligned." },
                                    { text: "Favorable Tax Regime — 0% corporate tax, no capital gains tax." },
                                    { text: "Residency via Investment — investor and entrepreneur programs available." },
                                    { text: "Business Gateway — relocate companies, funds, and family offices." },
                                    { text: "Lifestyle Benefits — high quality of life, safe environment, UK schooling system." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency Pathways in the Isle of Man"
                        blocks={[
                            {
                                title: "Investor Visa Route",
                                items: [
                                    { text: "Residency by investing a minimum GBP 2 million in qualifying assets." },
                                    { text: "Includes government bonds, IoM businesses, or regulated financial entities." },
                                    { text: "Pathway to permanent residency and British citizenship over time." }
                                ]
                            },
                            {
                                title: "Entrepreneur Visa Route",
                                items: [
                                    { text: "Residency for individuals establishing or joining an Isle of Man business." },
                                    { text: "Minimum investment requirement (approx. GBP 50,000)." },
                                    { text: "Ideal for fintech, iGaming, and financial services entrepreneurs." }
                                ]
                            },
                            {
                                title: "Business Relocation Residency",
                                items: [
                                    { text: "Residency granted by relocating an existing offshore company, fund, or family office to IoM." },
                                    { text: "Strong appeal for wealth managers, insurers, and fund operators." }
                                ]
                            },
                            {
                                title: "Work & Skilled Professional Residency",
                                items: [
                                    { text: "Residency route for skilled professionals and executives in banking, fintech, funds, or gaming." },
                                    { text: "Popular with executives of licensed IoM companies." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Tax Benefits of Isle of Man Residency"
                        blocks={[
                            {
                                items: [
                                    { text: "Corporate Tax: 0% (except for banks and local land-related activities)." },
                                    { text: "Capital Gains Tax: none." },
                                    { text: "Inheritance Tax: none." },
                                    { text: "Personal Tax: low personal income tax, capped at 20%." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Benefits of Isle of Man Residency"
                        blocks={[
                            {
                                items: [
                                    { text: "UK Connection — pathway to British citizenship." },
                                    { text: "Wealth & Asset Protection — stable, tax-efficient environment." },
                                    { text: "Business Friendly — strong support for fintech, funds, and iGaming." },
                                    { text: "Investor Confidence — credibility with global financial institutions." },
                                    { text: "Safe Relocation — excellent education, healthcare, and lifestyle." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Application Process"
                        blocks={[
                            {
                                items: [
                                    { text: "Consultation — choose investor, entrepreneur, or relocation route." },
                                    { text: "Document Preparation — financial proof, business plan, compliance documents." },
                                    { text: "Application Submission — filed with Isle of Man immigration authorities." },
                                    { text: "Approval & Residency — typically 2–6 months." },
                                    { text: "Long-Term Pathway — residency leads to permanent settlement and UK citizenship." }
                                ]
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Investor Visa",
                                description: "GBP 2m+ investment",
                            },
                            {
                                name: "Entrepreneur Visa",
                                description: "GBP 50k+ business investment",
                            },
                            {
                                name: "Processing Time",
                                description: "2–6 months",
                            },
                            {
                                name: "Professional Fees",
                                description: "Depends on route and application complexity",
                            },
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Expertise in IoM business, financial, and residency solutions" },
                                { text: "Guidance on choosing the best residency route for investors & families" },
                                { text: "Integration with banking, tax, and wealth management services" },
                                { text: "Comparative insights: Isle of Man vs Malta vs Cyprus vs Guernsey" },
                                { text: "End-to-end support: applications, relocations, and renewals" }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to secure residency in a Tier-1 jurisdiction?"
                        description="The Isle of Man offers investor, entrepreneur, and relocation residency programs, backed by a favorable tax system and global credibility."
                        buttonText="Book an Isle of Man Residency Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Is IoM part of the UK?",
        answer: "No — it is a self-governing British Crown Dependency, but residents enjoy many UK-linked benefits.",
    },
    {
        question: "Can IoM residency lead to UK citizenship?",
        answer: "Yes — through long-term residency and naturalization.",
    },
    {
        question: "How much do I need to invest?",
        answer: "GBP 2m+ for Investor Visa, GBP 50k+ for Entrepreneur route.",
    },
    {
        question: "Is IoM tax efficient?",
        answer: "Yes — 0% corporate tax, no CGT, no inheritance tax.",
    },
    {
        question: "How long does the process take?",
        answer: "2–6 months, depending on residency route.",
    },
];

const testimonialsData = [
    {
        quote: "The IoM investor visa gave us a safe base in Europe with access to UK benefits. Offshore Advisory guided us through every step.",
        author: "Ahmed R.",
        role: "Investor"
    },
    {
        quote: "We relocated our fintech company to the Isle of Man. Offshore Advisory managed both the business and residency process.",
        author: "Laura D.",
        role: "Entrepreneur"
    }
];
